import type { Entry } from "contentful";

const symbs = {
	moduleTitleRichText: "moduleTitleRichText",
	moduleStack: "appModuleImpactStack",
	moduleFAQ: "moduleFaq",
	stack: "stack",
	block: "block",
	sectionTitle: "sectionTitle",
	faqList: "faqList",
	else: () => true,
};

// utils
const undefinedFallback = (val, fallback = null) =>
	typeof val !== "undefined" ? val : fallback;

const cond = (...pCPairs) => {
	const pCPair = pCPairs.find(([predicate, _]) => predicate());
	const [_, consequent] = pCPair || [null, null];
	return consequent;
};

// module methods
const getContentType = (m) => undefinedFallback(m?.sys?.contentType?.sys?.id);

const isFAQModule = (m) => getContentType(m) === symbs.moduleFAQ;

const makeFAQList = (faqModule) => {
	const makeFAQItem = (faqItemModule) => ({
		title: faqItemModule.fields?.title,
		content: faqItemModule.fields?.content,
	});

	return {
		type: symbs.faqList,
		title: faqModule.fields?.title,
		items: faqModule.fields?.items?.map(makeFAQItem),
	};
};

const getModuleMaker = (m) =>
	cond([() => isFAQModule(m), makeFAQList], [symbs.else, () => ({})]);

// defined using function kw to make use of JS hoisting
function transformModule(m) {
	return getModuleMaker(m)(m);
}

export type CombinedPageEntry = Entry<{
	name: string;
	extraData: string | null;
	modules: Array<Entry<Object>>;
}>;

class FAQPage {
	public static EntryTypes = {
		stack: symbs.stack,
		block: symbs.block,
		sectionTitle: symbs.sectionTitle,
		faqList: symbs.faqList,
	};

	public static EmptyConstructorParams: any = {
		fields: {
			name: "",
			extraData: null,
			modules: [],
		},
	};
	public static ConstructEmpty = (): FAQPage => {
		return new FAQPage(FAQPage.EmptyConstructorParams);
	};

	public static Construct = (pageEntry: CombinedPageEntry): FAQPage => {
		return new FAQPage(pageEntry);
	};

	pageEntry: CombinedPageEntry;

	constructor(pageEntry: CombinedPageEntry) {
		this.pageEntry = pageEntry;
	}

	get imageURL(): string | null {
		if (
			this.pageEntry.fields?.modules &&
			this.pageEntry.fields?.modules.length > 0
		) {
			const firstModule = this.pageEntry.fields?.modules[0] as Entry<{
				image: { fields: { file: { url: string } } };
			}>;
			const url = firstModule.fields?.image?.fields?.file?.url;
			return url ? `https:${url}` : "";
		}

		return null;
	}

	get items(): Array<Object> {
		return this.pageEntry.fields?.modules.map(transformModule);
	}
}

export default FAQPage;
